import { memo } from 'react';
import Icon from '@ant-design/icons';
import { ReactComponent as ImgIcon } from './assets/img.svg';
import { ReactComponent as PdfIcon } from './assets/pdf.svg';
import { ReactComponent as TxtIcon } from './assets/txt.svg';
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon';

interface FileIconProps {
  ext: string;
  className?: IconBaseProps['className'];
}

export const FileIcon = memo((props: FileIconProps) => {
  const { ext, ...iconProps } = props;

  let type = ext;
  if (type.startsWith('.')) {
    type = type.substring(1);
  }

  if (type === 'jpg' || type === 'png' || type === 'jpeg') {
    return <Icon {...iconProps} component={ImgIcon} />;
  }

  if (type === 'pdf') {
    return <Icon {...iconProps} component={PdfIcon} />;
  }

  if (type === 'txt') {
    return <Icon {...iconProps} component={TxtIcon} />;
  }

  return null;
});
